import { memo, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { AnswerSheet } from '@smartintegrity/questionnaire';
import { Row, Col, Card, CardHeader, CardBody, Collapse } from 'reactstrap';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import { API_BASE_URL } from '../../../constants';
import { gdprQuestionnaireDetailToAnswerSheet } from '../../../helpers/questionnaireDetailAdapter';

import './style.scss';

const ReportContents = function (props) {
    const [isOpen, setIsOpen] = useState(true);

    const answerSheetData = useMemo(() => {
        return gdprQuestionnaireDetailToAnswerSheet(props.questions);
    }, [props.questions]);

    const answerSheetSettings = useMemo(() => {
        return {
            buttons: {
                back: {
                    enabled: false,
                },
                confirm: {
                    enabled: false,
                },
            },
            fileDownloaderOptions: {
                downloadRequestOptions: {
                    headers: {
                        Authorization: `Bearer ${props.token}`,
                    },
                    payload: {},
                    requestUrl: ({ attachmentId }) => {
                        return `${API_BASE_URL}/report/attachment/${attachmentId}/download`;
                    },
                },
            },
        };
    }, [props.token]);

    return (
        <Row>
            <Col sm='12'>
                <Card className='mb-1 shadow-none'>
                    {/* header */}
                    <Link
                        to='#'
                        onClick={() => {
                            setIsOpen(!isOpen);
                        }}
                        style={{ cursor: 'pointer' }}
                        className='text-dark'>
                        <CardHeader id='headingOne' className='org-primary-header'>
                            <h6 className='m-0 font-14'>
                                {props.t('Contents')}
                                <i className={`float-end accor-plus-icon mdi ${isOpen ? 'mdi-minus' : 'mdi-plus'}`}></i>
                            </h6>
                        </CardHeader>
                    </Link>

                    <Collapse isOpen={isOpen}>
                        <CardBody className='gdpr-report-contents' style={{ paddingLeft: '2px' }}>
                            <AnswerSheet
                                settings={answerSheetSettings}
                                questions={answerSheetData.questions}
                                answers={answerSheetData.answers}
                                multiTab={answerSheetData.multiTab}
                            />
                        </CardBody>
                    </Collapse>
                </Card>
            </Col>
        </Row>
    );
};

const mapStateToProps = (state) => {
    return {
        token: state.Login.token,
    };
};

export default withNamespaces()(
    connect(mapStateToProps)(
        memo(ReportContents)
    )
);